import React from 'react';
import { Link } from 'react-router-dom';
import { Icons as I } from '../pack-icons';

/**
 * FirstRunHero — empty-state hero shown when no schedule + no published posts.
 * checklist: [{ label, sub, done, cta, to?, onAction? }]
 */
export default function FirstRunHero({ checklist = [] }) {
  const done = checklist.filter((c) => c.done).length;
  return (
    <>
      <section className="fr-hero">
        <div className="fr-hero-bg" />
        <div className="fr-hero-inner">
          <span className="pill pill-accent" style={{ marginBottom: 16 }}>
            <span className="dot" />Start here
          </span>
          <h2 className="fr-h">
            No content yet —<br />
            <span className="fr-h-ac">let's generate your first batch.</span>
          </h2>
          <p className="fr-p">
            Your brand voice, audience, and offer are already configured. Pick a starter and we'll put them to work.
          </p>
          <div className="fr-cards">
            <Link to="/app/create" className="fr-card fr-card-primary">
              <span className="fr-card-ico"><I.sparkles size={18} /></span>
              <div className="fr-card-text">
                <h4>Generate first batch</h4>
                <p>Posts across your active platforms, ready in minutes.</p>
              </div>
              <span className="fr-card-cta">
                <span>Start</span>
                <I.arrowRight size={13} />
              </span>
            </Link>
            <Link to="/app/plan" className="fr-card">
              <span className="fr-card-ico"><I.target size={16} /></span>
              <div className="fr-card-text">
                <h4>Build a content plan</h4>
                <p>Pillars → cadence → calendar. Then auto-fill it.</p>
              </div>
              <I.arrowRight size={13} className="fr-card-arr" />
            </Link>
            <Link to="/app/settings?tab=social" className="fr-card">
              <span className="fr-card-ico"><I.users size={16} /></span>
              <div className="fr-card-text">
                <h4>Connect social accounts</h4>
                <p>Pick the platforms you want Dathent to publish to.</p>
              </div>
              <I.arrowRight size={13} className="fr-card-arr" />
            </Link>
          </div>
        </div>
      </section>

      {checklist.length > 0 && (
        <section className="card fr-checklist">
          <div className="fr-cl-head">
            <div>
              <div className="eyebrow"><span>Setup</span></div>
              <h3>{done} of {checklist.length} complete</h3>
            </div>
            <div className="fr-cl-bar">
              <div className="fr-cl-bar-fill" style={{ width: ((done / checklist.length) * 100) + '%' }} />
            </div>
          </div>
          <div className="fr-cl-list">
            {checklist.map((c, i) => (
              <div key={i} className={`fr-cl-item ${c.done ? 'is-done' : ''}`}>
                <span className="fr-cl-check">
                  {c.done ? <I.check size={12} /> : <span className="dot" style={{ background: 'currentColor', opacity: 0.4 }} />}
                </span>
                <div className="fr-cl-text">
                  <div className="fr-cl-title">{c.label}</div>
                  <div className="fr-cl-sub">{c.sub}</div>
                </div>
                {!c.done && c.cta && (
                  c.to ? (
                    <Link to={c.to} className="btn btn-soft btn-sm">
                      {c.cta} <I.arrowRight size={11} />
                    </Link>
                  ) : (
                    <button className="btn btn-soft btn-sm" onClick={c.onAction} type="button">
                      {c.cta} <I.arrowRight size={11} />
                    </button>
                  )
                )}
                {c.done && (
                  <span className="pill pill-success" style={{ height: 22 }}>
                    <I.check size={10} />Done
                  </span>
                )}
              </div>
            ))}
          </div>
        </section>
      )}
    </>
  );
}
